/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ChatData,
  DirectMessagesChat,
  DirectMessagesChatAuth,
  DirectMessagesChatRequest,
  GigSerializerForConfirmedPro,
  GigShiftAnnouncement,
  GigShiftAnnouncementRequest,
  MessagingSupportChannelsListParams,
  PaginatedSupportChannelList,
  ProAuth,
  ProChatData,
  SupportChannel,
  SupportChannelRequest,
  UnreadMessageCount
} from '../model';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getMessagingAnnouncementsCreateUrl = () => {




  return `/api/messaging/announcements/`
}

/**
 * Send an announcement Sendbird text message to all confirmed pros in all non-cancelled gigs for a shift.
 */
export const messagingAnnouncementsCreate = async (gigShiftAnnouncementRequest: GigShiftAnnouncementRequest, options?: Parameters<typeof customFetch>[1]): Promise<GigShiftAnnouncement> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<GigShiftAnnouncement>(getMessagingAnnouncementsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(gigShiftAnnouncementRequest)
  }
);}





export const getMessagingAnnouncementsCreateMutationKey = () => ['messagingAnnouncementsCreate'] as const;

export const getMessagingAnnouncementsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingAnnouncementsCreate>>, TError,MessagingAnnouncementsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof messagingAnnouncementsCreate>>, TError,MessagingAnnouncementsCreateMutationVariables, TContext> => {

const mutationKey = getMessagingAnnouncementsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof messagingAnnouncementsCreate>>, MessagingAnnouncementsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  messagingAnnouncementsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MessagingAnnouncementsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof messagingAnnouncementsCreate>>>
    export type MessagingAnnouncementsCreateMutationBody = GigShiftAnnouncementRequest
    export type MessagingAnnouncementsCreateMutationError = void
    export type MessagingAnnouncementsCreateMutationVariables = {data: GigShiftAnnouncementRequest}

    export const useMessagingAnnouncementsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingAnnouncementsCreate>>, TError,MessagingAnnouncementsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof messagingAnnouncementsCreate>>,
        TError,
        MessagingAnnouncementsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getMessagingAnnouncementsCreateMutationOptions(options), queryClient);
    }
    export const getMessagingChatRetrieveUrl = (token: string,) => {




  return `/api/messaging/chat/${token}/`
}

export const messagingChatRetrieve = async (token: string, options?: Parameters<typeof customFetch>[1]): Promise<ChatData> => {

  return customFetch<ChatData>(getMessagingChatRetrieveUrl(token),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMessagingChatRetrieveQueryKey = (token: string,) => {
    return [
    `/api/messaging/chat/${token}/`
    ] as const;
    }


export const getMessagingChatRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof messagingChatRetrieve>>, TError = void>(token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingChatRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMessagingChatRetrieveQueryKey(token);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof messagingChatRetrieve>>> = ({ signal }) => messagingChatRetrieve(token, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: token !== null && token !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof messagingChatRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MessagingChatRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof messagingChatRetrieve>>>
export type MessagingChatRetrieveQueryError = void


export function useMessagingChatRetrieve<TData = Awaited<ReturnType<typeof messagingChatRetrieve>>, TError = void>(
 token: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingChatRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof messagingChatRetrieve>>,
          TError,
          Awaited<ReturnType<typeof messagingChatRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessagingChatRetrieve<TData = Awaited<ReturnType<typeof messagingChatRetrieve>>, TError = void>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingChatRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof messagingChatRetrieve>>,
          TError,
          Awaited<ReturnType<typeof messagingChatRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessagingChatRetrieve<TData = Awaited<ReturnType<typeof messagingChatRetrieve>>, TError = void>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingChatRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useMessagingChatRetrieve<TData = Awaited<ReturnType<typeof messagingChatRetrieve>>, TError = void>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingChatRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMessagingChatRetrieveQueryOptions(token,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMessagingChatLocationAuthRetrieveUrl = (locationId: number,) => {




  return `/api/messaging/chat/location/${locationId}/auth/`
}

export const messagingChatLocationAuthRetrieve = async (locationId: number, options?: Parameters<typeof customFetch>[1]): Promise<DirectMessagesChatAuth> => {

  return customFetch<DirectMessagesChatAuth>(getMessagingChatLocationAuthRetrieveUrl(locationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMessagingChatLocationAuthRetrieveQueryKey = (locationId: number,) => {
    return [
    `/api/messaging/chat/location/${locationId}/auth/`
    ] as const;
    }


export const getMessagingChatLocationAuthRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof messagingChatLocationAuthRetrieve>>, TError = void>(locationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingChatLocationAuthRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMessagingChatLocationAuthRetrieveQueryKey(locationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof messagingChatLocationAuthRetrieve>>> = ({ signal }) => messagingChatLocationAuthRetrieve(locationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: locationId !== null && locationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof messagingChatLocationAuthRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MessagingChatLocationAuthRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof messagingChatLocationAuthRetrieve>>>
export type MessagingChatLocationAuthRetrieveQueryError = void


export function useMessagingChatLocationAuthRetrieve<TData = Awaited<ReturnType<typeof messagingChatLocationAuthRetrieve>>, TError = void>(
 locationId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingChatLocationAuthRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof messagingChatLocationAuthRetrieve>>,
          TError,
          Awaited<ReturnType<typeof messagingChatLocationAuthRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessagingChatLocationAuthRetrieve<TData = Awaited<ReturnType<typeof messagingChatLocationAuthRetrieve>>, TError = void>(
 locationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingChatLocationAuthRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof messagingChatLocationAuthRetrieve>>,
          TError,
          Awaited<ReturnType<typeof messagingChatLocationAuthRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessagingChatLocationAuthRetrieve<TData = Awaited<ReturnType<typeof messagingChatLocationAuthRetrieve>>, TError = void>(
 locationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingChatLocationAuthRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useMessagingChatLocationAuthRetrieve<TData = Awaited<ReturnType<typeof messagingChatLocationAuthRetrieve>>, TError = void>(
 locationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingChatLocationAuthRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMessagingChatLocationAuthRetrieveQueryOptions(locationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMessagingChatLocationUnreadCountRetrieveUrl = (locationId: number,) => {




  return `/api/messaging/chat/location/${locationId}/unread-count/`
}

/**
 * Returns unread Sendbird message count for requested location (must be location manager or gigpro admin)
 */
export const messagingChatLocationUnreadCountRetrieve = async (locationId: number, options?: Parameters<typeof customFetch>[1]): Promise<UnreadMessageCount> => {

  return customFetch<UnreadMessageCount>(getMessagingChatLocationUnreadCountRetrieveUrl(locationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMessagingChatLocationUnreadCountRetrieveQueryKey = (locationId: number,) => {
    return [
    `/api/messaging/chat/location/${locationId}/unread-count/`
    ] as const;
    }


export const getMessagingChatLocationUnreadCountRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof messagingChatLocationUnreadCountRetrieve>>, TError = void>(locationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingChatLocationUnreadCountRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMessagingChatLocationUnreadCountRetrieveQueryKey(locationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof messagingChatLocationUnreadCountRetrieve>>> = ({ signal }) => messagingChatLocationUnreadCountRetrieve(locationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: locationId !== null && locationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof messagingChatLocationUnreadCountRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MessagingChatLocationUnreadCountRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof messagingChatLocationUnreadCountRetrieve>>>
export type MessagingChatLocationUnreadCountRetrieveQueryError = void


export function useMessagingChatLocationUnreadCountRetrieve<TData = Awaited<ReturnType<typeof messagingChatLocationUnreadCountRetrieve>>, TError = void>(
 locationId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingChatLocationUnreadCountRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof messagingChatLocationUnreadCountRetrieve>>,
          TError,
          Awaited<ReturnType<typeof messagingChatLocationUnreadCountRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessagingChatLocationUnreadCountRetrieve<TData = Awaited<ReturnType<typeof messagingChatLocationUnreadCountRetrieve>>, TError = void>(
 locationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingChatLocationUnreadCountRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof messagingChatLocationUnreadCountRetrieve>>,
          TError,
          Awaited<ReturnType<typeof messagingChatLocationUnreadCountRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessagingChatLocationUnreadCountRetrieve<TData = Awaited<ReturnType<typeof messagingChatLocationUnreadCountRetrieve>>, TError = void>(
 locationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingChatLocationUnreadCountRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useMessagingChatLocationUnreadCountRetrieve<TData = Awaited<ReturnType<typeof messagingChatLocationUnreadCountRetrieve>>, TError = void>(
 locationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingChatLocationUnreadCountRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMessagingChatLocationUnreadCountRetrieveQueryOptions(locationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMessagingChatProListUrl = () => {




  return `/api/messaging/chat/pro/`
}

export const messagingChatProList = async ( options?: Parameters<typeof customFetch>[1]): Promise<ProChatData[] | void> => {

  return customFetch<ProChatData[] | void>(getMessagingChatProListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMessagingChatProListQueryKey = () => {
    return [
    `/api/messaging/chat/pro/`
    ] as const;
    }


export const getMessagingChatProListQueryOptions = <TData = Awaited<ReturnType<typeof messagingChatProList>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingChatProList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMessagingChatProListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof messagingChatProList>>> = ({ signal }) => messagingChatProList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof messagingChatProList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MessagingChatProListQueryResult = NonNullable<Awaited<ReturnType<typeof messagingChatProList>>>
export type MessagingChatProListQueryError = void


export function useMessagingChatProList<TData = Awaited<ReturnType<typeof messagingChatProList>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingChatProList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof messagingChatProList>>,
          TError,
          Awaited<ReturnType<typeof messagingChatProList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessagingChatProList<TData = Awaited<ReturnType<typeof messagingChatProList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingChatProList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof messagingChatProList>>,
          TError,
          Awaited<ReturnType<typeof messagingChatProList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessagingChatProList<TData = Awaited<ReturnType<typeof messagingChatProList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingChatProList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useMessagingChatProList<TData = Awaited<ReturnType<typeof messagingChatProList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingChatProList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMessagingChatProListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMessagingChatProRetrieveUrl = (applicationId: number,) => {




  return `/api/messaging/chat/pro/${applicationId}/`
}

export const messagingChatProRetrieve = async (applicationId: number, options?: Parameters<typeof customFetch>[1]): Promise<ProChatData> => {

  return customFetch<ProChatData>(getMessagingChatProRetrieveUrl(applicationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMessagingChatProRetrieveQueryKey = (applicationId: number,) => {
    return [
    `/api/messaging/chat/pro/${applicationId}/`
    ] as const;
    }


export const getMessagingChatProRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof messagingChatProRetrieve>>, TError = void>(applicationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingChatProRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMessagingChatProRetrieveQueryKey(applicationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof messagingChatProRetrieve>>> = ({ signal }) => messagingChatProRetrieve(applicationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: applicationId !== null && applicationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof messagingChatProRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MessagingChatProRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof messagingChatProRetrieve>>>
export type MessagingChatProRetrieveQueryError = void


export function useMessagingChatProRetrieve<TData = Awaited<ReturnType<typeof messagingChatProRetrieve>>, TError = void>(
 applicationId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingChatProRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof messagingChatProRetrieve>>,
          TError,
          Awaited<ReturnType<typeof messagingChatProRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessagingChatProRetrieve<TData = Awaited<ReturnType<typeof messagingChatProRetrieve>>, TError = void>(
 applicationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingChatProRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof messagingChatProRetrieve>>,
          TError,
          Awaited<ReturnType<typeof messagingChatProRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessagingChatProRetrieve<TData = Awaited<ReturnType<typeof messagingChatProRetrieve>>, TError = void>(
 applicationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingChatProRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useMessagingChatProRetrieve<TData = Awaited<ReturnType<typeof messagingChatProRetrieve>>, TError = void>(
 applicationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingChatProRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMessagingChatProRetrieveQueryOptions(applicationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMessagingChatProAuthRetrieveUrl = () => {




  return `/api/messaging/chat/pro/auth/`
}

export const messagingChatProAuthRetrieve = async ( options?: Parameters<typeof customFetch>[1]): Promise<ProAuth> => {

  return customFetch<ProAuth>(getMessagingChatProAuthRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMessagingChatProAuthRetrieveQueryKey = () => {
    return [
    `/api/messaging/chat/pro/auth/`
    ] as const;
    }


export const getMessagingChatProAuthRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof messagingChatProAuthRetrieve>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingChatProAuthRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMessagingChatProAuthRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof messagingChatProAuthRetrieve>>> = ({ signal }) => messagingChatProAuthRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof messagingChatProAuthRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MessagingChatProAuthRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof messagingChatProAuthRetrieve>>>
export type MessagingChatProAuthRetrieveQueryError = void


export function useMessagingChatProAuthRetrieve<TData = Awaited<ReturnType<typeof messagingChatProAuthRetrieve>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingChatProAuthRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof messagingChatProAuthRetrieve>>,
          TError,
          Awaited<ReturnType<typeof messagingChatProAuthRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessagingChatProAuthRetrieve<TData = Awaited<ReturnType<typeof messagingChatProAuthRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingChatProAuthRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof messagingChatProAuthRetrieve>>,
          TError,
          Awaited<ReturnType<typeof messagingChatProAuthRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessagingChatProAuthRetrieve<TData = Awaited<ReturnType<typeof messagingChatProAuthRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingChatProAuthRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useMessagingChatProAuthRetrieve<TData = Awaited<ReturnType<typeof messagingChatProAuthRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingChatProAuthRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMessagingChatProAuthRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMessagingChatProGigRetrieveUrl = (channelUrl: string,) => {




  return `/api/messaging/chat/pro/gig/${channelUrl}/`
}

export const messagingChatProGigRetrieve = async (channelUrl: string, options?: Parameters<typeof customFetch>[1]): Promise<GigSerializerForConfirmedPro> => {

  return customFetch<GigSerializerForConfirmedPro>(getMessagingChatProGigRetrieveUrl(channelUrl),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMessagingChatProGigRetrieveQueryKey = (channelUrl: string,) => {
    return [
    `/api/messaging/chat/pro/gig/${channelUrl}/`
    ] as const;
    }


export const getMessagingChatProGigRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof messagingChatProGigRetrieve>>, TError = void>(channelUrl: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingChatProGigRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMessagingChatProGigRetrieveQueryKey(channelUrl);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof messagingChatProGigRetrieve>>> = ({ signal }) => messagingChatProGigRetrieve(channelUrl, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: channelUrl !== null && channelUrl !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof messagingChatProGigRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MessagingChatProGigRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof messagingChatProGigRetrieve>>>
export type MessagingChatProGigRetrieveQueryError = void


export function useMessagingChatProGigRetrieve<TData = Awaited<ReturnType<typeof messagingChatProGigRetrieve>>, TError = void>(
 channelUrl: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingChatProGigRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof messagingChatProGigRetrieve>>,
          TError,
          Awaited<ReturnType<typeof messagingChatProGigRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessagingChatProGigRetrieve<TData = Awaited<ReturnType<typeof messagingChatProGigRetrieve>>, TError = void>(
 channelUrl: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingChatProGigRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof messagingChatProGigRetrieve>>,
          TError,
          Awaited<ReturnType<typeof messagingChatProGigRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessagingChatProGigRetrieve<TData = Awaited<ReturnType<typeof messagingChatProGigRetrieve>>, TError = void>(
 channelUrl: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingChatProGigRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useMessagingChatProGigRetrieve<TData = Awaited<ReturnType<typeof messagingChatProGigRetrieve>>, TError = void>(
 channelUrl: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingChatProGigRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMessagingChatProGigRetrieveQueryOptions(channelUrl,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMessagingChatProUnreadCountRetrieveUrl = () => {




  return `/api/messaging/chat/pro/unread-count/`
}

/**
 * Returns unread Sendbird message count for currently logged in user.
 */
export const messagingChatProUnreadCountRetrieve = async ( options?: Parameters<typeof customFetch>[1]): Promise<UnreadMessageCount> => {

  return customFetch<UnreadMessageCount>(getMessagingChatProUnreadCountRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMessagingChatProUnreadCountRetrieveQueryKey = () => {
    return [
    `/api/messaging/chat/pro/unread-count/`
    ] as const;
    }


export const getMessagingChatProUnreadCountRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof messagingChatProUnreadCountRetrieve>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingChatProUnreadCountRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMessagingChatProUnreadCountRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof messagingChatProUnreadCountRetrieve>>> = ({ signal }) => messagingChatProUnreadCountRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof messagingChatProUnreadCountRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MessagingChatProUnreadCountRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof messagingChatProUnreadCountRetrieve>>>
export type MessagingChatProUnreadCountRetrieveQueryError = void


export function useMessagingChatProUnreadCountRetrieve<TData = Awaited<ReturnType<typeof messagingChatProUnreadCountRetrieve>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingChatProUnreadCountRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof messagingChatProUnreadCountRetrieve>>,
          TError,
          Awaited<ReturnType<typeof messagingChatProUnreadCountRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessagingChatProUnreadCountRetrieve<TData = Awaited<ReturnType<typeof messagingChatProUnreadCountRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingChatProUnreadCountRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof messagingChatProUnreadCountRetrieve>>,
          TError,
          Awaited<ReturnType<typeof messagingChatProUnreadCountRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessagingChatProUnreadCountRetrieve<TData = Awaited<ReturnType<typeof messagingChatProUnreadCountRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingChatProUnreadCountRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useMessagingChatProUnreadCountRetrieve<TData = Awaited<ReturnType<typeof messagingChatProUnreadCountRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingChatProUnreadCountRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMessagingChatProUnreadCountRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMessagingChatStafferAuthRetrieveUrl = (userId: number,) => {




  return `/api/messaging/chat/staffer/${userId}/auth/`
}

export const messagingChatStafferAuthRetrieve = async (userId: number, options?: Parameters<typeof customFetch>[1]): Promise<DirectMessagesChatAuth> => {

  return customFetch<DirectMessagesChatAuth>(getMessagingChatStafferAuthRetrieveUrl(userId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMessagingChatStafferAuthRetrieveQueryKey = (userId: number,) => {
    return [
    `/api/messaging/chat/staffer/${userId}/auth/`
    ] as const;
    }


export const getMessagingChatStafferAuthRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof messagingChatStafferAuthRetrieve>>, TError = void>(userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingChatStafferAuthRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMessagingChatStafferAuthRetrieveQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof messagingChatStafferAuthRetrieve>>> = ({ signal }) => messagingChatStafferAuthRetrieve(userId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof messagingChatStafferAuthRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MessagingChatStafferAuthRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof messagingChatStafferAuthRetrieve>>>
export type MessagingChatStafferAuthRetrieveQueryError = void


export function useMessagingChatStafferAuthRetrieve<TData = Awaited<ReturnType<typeof messagingChatStafferAuthRetrieve>>, TError = void>(
 userId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingChatStafferAuthRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof messagingChatStafferAuthRetrieve>>,
          TError,
          Awaited<ReturnType<typeof messagingChatStafferAuthRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessagingChatStafferAuthRetrieve<TData = Awaited<ReturnType<typeof messagingChatStafferAuthRetrieve>>, TError = void>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingChatStafferAuthRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof messagingChatStafferAuthRetrieve>>,
          TError,
          Awaited<ReturnType<typeof messagingChatStafferAuthRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessagingChatStafferAuthRetrieve<TData = Awaited<ReturnType<typeof messagingChatStafferAuthRetrieve>>, TError = void>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingChatStafferAuthRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useMessagingChatStafferAuthRetrieve<TData = Awaited<ReturnType<typeof messagingChatStafferAuthRetrieve>>, TError = void>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingChatStafferAuthRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMessagingChatStafferAuthRetrieveQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMessagingDirectMessagesChatCreateUrl = () => {




  return `/api/messaging/direct-messages/chat/`
}

export const messagingDirectMessagesChatCreate = async (directMessagesChatRequest: DirectMessagesChatRequest, options?: Parameters<typeof customFetch>[1]): Promise<DirectMessagesChat> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<DirectMessagesChat>(getMessagingDirectMessagesChatCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(directMessagesChatRequest)
  }
);}





export const getMessagingDirectMessagesChatCreateMutationKey = () => ['messagingDirectMessagesChatCreate'] as const;

export const getMessagingDirectMessagesChatCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingDirectMessagesChatCreate>>, TError,MessagingDirectMessagesChatCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof messagingDirectMessagesChatCreate>>, TError,MessagingDirectMessagesChatCreateMutationVariables, TContext> => {

const mutationKey = getMessagingDirectMessagesChatCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof messagingDirectMessagesChatCreate>>, MessagingDirectMessagesChatCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  messagingDirectMessagesChatCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MessagingDirectMessagesChatCreateMutationResult = NonNullable<Awaited<ReturnType<typeof messagingDirectMessagesChatCreate>>>
    export type MessagingDirectMessagesChatCreateMutationBody = DirectMessagesChatRequest
    export type MessagingDirectMessagesChatCreateMutationError = void
    export type MessagingDirectMessagesChatCreateMutationVariables = {data: DirectMessagesChatRequest}

    export const useMessagingDirectMessagesChatCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingDirectMessagesChatCreate>>, TError,MessagingDirectMessagesChatCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof messagingDirectMessagesChatCreate>>,
        TError,
        MessagingDirectMessagesChatCreateMutationVariables,
        TContext
      > => {
      return useMutation(getMessagingDirectMessagesChatCreateMutationOptions(options), queryClient);
    }
    export const getMessagingSupportChannelsListUrl = (params?: MessagingSupportChannelsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/messaging/support-channels/?${stringifiedParams}` : `/api/messaging/support-channels/`
}

export const messagingSupportChannelsList = async (params?: MessagingSupportChannelsListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedSupportChannelList> => {

  return customFetch<PaginatedSupportChannelList>(getMessagingSupportChannelsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMessagingSupportChannelsListInfiniteQueryKey = (params?: MessagingSupportChannelsListParams,) => {
    return [
    'infinite', `/api/messaging/support-channels/`, ...(params ? [params] : [])
    ] as const;
    }

export const getMessagingSupportChannelsListQueryKey = (params?: MessagingSupportChannelsListParams,) => {
    return [
    `/api/messaging/support-channels/`, ...(params ? [params] : [])
    ] as const;
    }


export const getMessagingSupportChannelsListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof messagingSupportChannelsList>>, MessagingSupportChannelsListParams['page']>, TError = void>(params?: MessagingSupportChannelsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof messagingSupportChannelsList>>, TError, TData, QueryKey, MessagingSupportChannelsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMessagingSupportChannelsListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof messagingSupportChannelsList>>, QueryKey, MessagingSupportChannelsListParams['page']> = ({ signal, pageParam }) => messagingSupportChannelsList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof messagingSupportChannelsList>>, TError, TData, QueryKey, MessagingSupportChannelsListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MessagingSupportChannelsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof messagingSupportChannelsList>>>
export type MessagingSupportChannelsListInfiniteQueryError = void


export function useMessagingSupportChannelsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof messagingSupportChannelsList>>, MessagingSupportChannelsListParams['page']>, TError = void>(
 params: undefined |  MessagingSupportChannelsListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof messagingSupportChannelsList>>, TError, TData, QueryKey, MessagingSupportChannelsListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof messagingSupportChannelsList>>,
          TError,
          Awaited<ReturnType<typeof messagingSupportChannelsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessagingSupportChannelsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof messagingSupportChannelsList>>, MessagingSupportChannelsListParams['page']>, TError = void>(
 params?: MessagingSupportChannelsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof messagingSupportChannelsList>>, TError, TData, QueryKey, MessagingSupportChannelsListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof messagingSupportChannelsList>>,
          TError,
          Awaited<ReturnType<typeof messagingSupportChannelsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessagingSupportChannelsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof messagingSupportChannelsList>>, MessagingSupportChannelsListParams['page']>, TError = void>(
 params?: MessagingSupportChannelsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof messagingSupportChannelsList>>, TError, TData, QueryKey, MessagingSupportChannelsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useMessagingSupportChannelsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof messagingSupportChannelsList>>, MessagingSupportChannelsListParams['page']>, TError = void>(
 params?: MessagingSupportChannelsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof messagingSupportChannelsList>>, TError, TData, QueryKey, MessagingSupportChannelsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMessagingSupportChannelsListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMessagingSupportChannelsListQueryOptions = <TData = Awaited<ReturnType<typeof messagingSupportChannelsList>>, TError = void>(params?: MessagingSupportChannelsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingSupportChannelsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMessagingSupportChannelsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof messagingSupportChannelsList>>> = ({ signal }) => messagingSupportChannelsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof messagingSupportChannelsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MessagingSupportChannelsListQueryResult = NonNullable<Awaited<ReturnType<typeof messagingSupportChannelsList>>>
export type MessagingSupportChannelsListQueryError = void


export function useMessagingSupportChannelsList<TData = Awaited<ReturnType<typeof messagingSupportChannelsList>>, TError = void>(
 params: undefined |  MessagingSupportChannelsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingSupportChannelsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof messagingSupportChannelsList>>,
          TError,
          Awaited<ReturnType<typeof messagingSupportChannelsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessagingSupportChannelsList<TData = Awaited<ReturnType<typeof messagingSupportChannelsList>>, TError = void>(
 params?: MessagingSupportChannelsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingSupportChannelsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof messagingSupportChannelsList>>,
          TError,
          Awaited<ReturnType<typeof messagingSupportChannelsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessagingSupportChannelsList<TData = Awaited<ReturnType<typeof messagingSupportChannelsList>>, TError = void>(
 params?: MessagingSupportChannelsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingSupportChannelsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useMessagingSupportChannelsList<TData = Awaited<ReturnType<typeof messagingSupportChannelsList>>, TError = void>(
 params?: MessagingSupportChannelsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingSupportChannelsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMessagingSupportChannelsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMessagingSupportChannelsCreateUrl = () => {




  return `/api/messaging/support-channels/`
}

export const messagingSupportChannelsCreate = async (supportChannelRequest: SupportChannelRequest, options?: Parameters<typeof customFetch>[1]): Promise<SupportChannel> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<SupportChannel>(getMessagingSupportChannelsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(supportChannelRequest)
  }
);}





export const getMessagingSupportChannelsCreateMutationKey = () => ['messagingSupportChannelsCreate'] as const;

export const getMessagingSupportChannelsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingSupportChannelsCreate>>, TError,MessagingSupportChannelsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof messagingSupportChannelsCreate>>, TError,MessagingSupportChannelsCreateMutationVariables, TContext> => {

const mutationKey = getMessagingSupportChannelsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof messagingSupportChannelsCreate>>, MessagingSupportChannelsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  messagingSupportChannelsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MessagingSupportChannelsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof messagingSupportChannelsCreate>>>
    export type MessagingSupportChannelsCreateMutationBody = SupportChannelRequest
    export type MessagingSupportChannelsCreateMutationError = void
    export type MessagingSupportChannelsCreateMutationVariables = {data: SupportChannelRequest}

    export const useMessagingSupportChannelsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingSupportChannelsCreate>>, TError,MessagingSupportChannelsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof messagingSupportChannelsCreate>>,
        TError,
        MessagingSupportChannelsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getMessagingSupportChannelsCreateMutationOptions(options), queryClient);
    }
